import { render, staticRenderFns } from "./NewFile.vue?vue&type=template&id=508c5f58&"
import script from "./NewFile.vue?vue&type=script&lang=js&"
export * from "./NewFile.vue?vue&type=script&lang=js&"
import style0 from "./NewFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports